import * as React from 'react';

import {FeatureGateModalWrapper} from '../../../limits/feature-gates/feature-gate-modal-wrapper';

type Props = {
    isOpen: boolean;
    onClose: () => void;
};

export function SsoFeatureGateModal(props: Props) {
    return (
        <FeatureGateModalWrapper
            isOpen={props.isOpen}
            onClose={props.onClose}
            title='Sign in using your identity provider'
            description='Use single sign-on to secure your company’s Nutshell account.'
            bullets={[
                'Compatible with Google, Microsoft, Okta, Duo, and any SAML-compatible identity provider.',
                'Allows for password-free logins, with multi-factor authentication provided by your identity provider.',
                'Requires at least 5 Nutshell users.',
            ]}
            feature='sso'
        />
    );
}
